import React, { useEffect, useMemo } from 'react';
import InfiniteMediaLibrary, {
  GridTileType,
} from '~/App/Modules/MyLibrary/Components/InfiniteMediaLibrary';
import EmptyUploadVideo from '~/App/Modules/MyLibrary/Components/EmptyUploadVideo';
import Empty from '~/App/Modules/MyLibrary/Components/Empty';
import { InfiniteMediaItemConfigProps } from '~/App/Modules/MyLibrary/Context/infinite-media-item-config-context';
import { AssetPageProps } from './AllDisplay';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import { usePublishSelectModalContext } from '~/App/Modules/Testimonials/Pages/Publish/Editor/Contexts/PublishSelectModalContext';
import { PaginationMetadata, UsePagination } from '~/react-hooks/usePagination';
import { MediaLibraryAsset } from '~/App/Modules/MyLibrary/Components/InfiniteMediaLibraryItem';
import { usePublishPageContext } from '~/App/Modules/Testimonials/Pages/Publish/Editor/Contexts/PublishPageContext';

const UploadVideoButton = () => {
  return (
    <Button
      className='h-10'
      variant={ButtonVariant.Primary}
      //TODO: source from an .env or file the url for testimonials uploads
      onClick={() => (window.location.href = '/projects/assets/uploads')}
    >
      <span className='flex items-center justify-center truncate gap-3'>
        <i className='icon icon-cloud-upload !h-[21px] !bg-neutral-900' />
        Upload Video
      </span>
    </Button>
  );
};

const UploadsDisplay = ({
  perPage = 16,
  scrollContainerRef,
  isItemSelectDisabled,
}: AssetPageProps) => {
  const publishSelectModalContext = usePublishSelectModalContext()!;

  const {
    userAssetsPagination,
    selectedUserAssetsPagination,
    invalidateUserAssetsQueries,
    setPerPage,
    addSelectedId,
    removeSelectedId,
    selectedIds,
    filteredTags,
    getFilteredTagCollection,
    clearSelectedTags,
  } = publishSelectModalContext;

  const publishContext = usePublishPageContext();

  const savedSelectedIds = publishContext?.publish?.publishable_resources || [];

  useEffect(() => {
    setPerPage(perPage);
  }, [perPage]);

  const invalidateQueries = () => {
    invalidateUserAssetsQueries();
  };

  const hasTextAssets =
    !!userAssetsPagination?.[2].total ||
    !!selectedUserAssetsPagination?.[2].total;
  const isLoading =
    userAssetsPagination?.[2].loading ||
    selectedUserAssetsPagination?.[2].loading;

  const paginationData = useMemo(() => {
    const data: UsePagination<MediaLibraryAsset, PaginationMetadata>[] = [];

    if (savedSelectedIds.length && selectedUserAssetsPagination) {
      data.push(selectedUserAssetsPagination);
    }

    if (userAssetsPagination) {
      data.push(userAssetsPagination);
    }

    return data;
  }, [savedSelectedIds, selectedUserAssetsPagination, userAssetsPagination]);

  if (Object.keys(filteredTags).length === 0 && !isLoading && !hasTextAssets) {
    return (
      <Empty
        title="You haven't uploaded any testimonials yet"
        subtitle='Upload your existing assets'
        cta={<UploadVideoButton />}
      ></Empty>
    );
  }

  return (
    <>
      <InfiniteMediaLibrary
        perPage={perPage}
        paginationData={paginationData}
        onTagUpdated={invalidateQueries}
        orderByCreatedAt={false}
        emptyComponent={
          <EmptyUploadVideo
            tags={getFilteredTagCollection()}
            clearTags={clearSelectedTags}
            showDragAndDropBanner
          />
        }
        scrollContainerRef={scrollContainerRef}
        gridTileType={GridTileType.Dynamic}
        itemConfig={
          {
            hideInteractionStats: true,
            selectMode: true,
          } as InfiniteMediaItemConfigProps
        }
        addSelectedId={addSelectedId}
        removeSelectedId={removeSelectedId}
        selectedIds={selectedIds}
        isItemSelectDisabled={isItemSelectDisabled}
      />
    </>
  );
};

export default UploadsDisplay;
